import { AccessGate } from '../../shared/access/AccessControls';
import { useAllowedMutation } from '../../shared/access/AccessControls';
import React, { useEffect } from 'react';
import MainLayout from '../../shared/components/MainLayout';
import { Button, Flex, Icon, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';
import ButtonLink from '../../shared/components/ui/Button/ButtonLink';
import { Paths } from '../../router/routes';
import { useAppSelector } from '../../store/hooks';
import Card from '../../shared/components/ui/Card/Card';
import ResponsiveTable from '../../shared/components/table/ResponsiveTable';
import AddTagModal from './AddTagModal';
import AlertDialog from '../../shared/components/custom/AlertDialog/AlertDialog';
import { AiOutlineClose } from 'react-icons/ai';
import { mediaLibraryTagsApi } from '../../store/services/MediaLibraryTagsService';
import { selectMlTags } from '../../store/slices/mediaLibraryTagsSlice';
import { MLTag } from '../../shared/types/mediaLibraryTag';

const MediaLibraryTags = () => {
  const tags = useAppSelector(selectMlTags);

  const [trigger] = mediaLibraryTagsApi.useLazyGetAllMlTagsQuery();
  const [deleteTag] = useAllowedMutation(mediaLibraryTagsApi.useDeleteMlTagByIdMutation, 'deleteMlTagById');

  useEffect(() => {
    trigger({});
  }, []);

  const onDelete = (tagId: string) => () => {
    deleteTag(tagId);
  };

  return (
    <MainLayout>
      <Flex mb={4} gridGap={'1rem'}>
        <AddTagModal activator={<Button colorScheme="blue">Add new</Button>} />
      </Flex>

      <Card noPadding>
        <ResponsiveTable>
          <Thead>
            <Tr>
              <Th w={'10%'}>Creation</Th>
              <Th w={'10%'}>Type</Th>
              <Th w={'20%'}>Translation key</Th>
              <Th w={'20%'}>Value</Th>
              <Th />
            </Tr>
          </Thead>
          <Tbody>
            {tags.length > 0 &&
              tags.map((tag: MLTag) => (
                <Tr key={tag.id}>
                  <Td w={'10%'}>{tag.creation}</Td>
                  <Td w={'10%'}>{tag.type}</Td>
                  <Td w={'20%'} wordBreak={'break-word'}>
                    {tag.label}
                  </Td>
                  <Td w={'20%'} wordBreak={'break-word'}>
                    {tag.value}
                  </Td>
                  <Td>
                    <Flex justifyContent={'flex-end'} gridGap={'1rem'}>
                      <ButtonLink
                        colorScheme={'blue'}
                        to={`${Paths.mediaLibraryTags}/${tag.id}`}
                      >
                        Open
                      </ButtonLink>
                      <AccessGate action="legacyFilerAdminOnly"><AlertDialog
                        title={`Are you sure you want to DELETE tag "${tag.value}"`}
                        confirmLabel={'Delete'}
                        confirmColorScheme={'red'}
                        onConfirm={onDelete(tag.id)}
                        activator={
                          <Button colorScheme={'gray'} title={'Delete'}>
                            <Icon as={AiOutlineClose} />
                          </Button>
                        }
                      /></AccessGate>
                    </Flex>
                  </Td>
                </Tr>
              ))}
          </Tbody>
        </ResponsiveTable>
      </Card>
    </MainLayout>
  );
};

export default MediaLibraryTags;
